import { useMutation, useQueryClient } from '@tanstack/react-query';
import { startTenantProtection, validateToken } from '../api/tenantProtection/getTenantProtection';

export const useStartTenantProtection = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isSuccess } = useMutation(startTenantProtection, {
    onSuccess: () => queryClient.invalidateQueries(['products-status']),
    onError: () => queryClient.invalidateQueries(['products-status']),
  });

  return {
    isSuccess,
    mutate: mutateAsync,
  };
};

export const useValidateTenantProtection = () => {
  const { mutateAsync, isSuccess, isLoading, isError } = useMutation(async ({ token }: { token: string }) => {
    const data = await validateToken(token);
    return data;
  });

  return {
    isLoading,
    isError,
    isSuccess,
    mutate: mutateAsync,
  };
};
